var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.95","cx":"50","cy":"50","r":"50","fill":"#565656","key":0}),React.createElement("path",{"d":"M72 48.2679C73.3333 49.0377 73.3333 50.9623 72 51.7321L40.5 69.9186C39.1667 70.6884 37.5 69.7261 37.5 68.1865V31.8135C37.5 30.2739 39.1667 29.3116 40.5 30.0814L72 48.2679Z","fill":"white","key":1})]);
}

PlayIconInline.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
